export default __webpack_public_path__ + "static/media/sb.828b2f11.svg";